module.exports = __webpack_public_path__ + "static/media/stopoverImage.654201ad.svg";